import Tabs from "@/components/common/tab/Tab";
import DataSelect from "@/components/common/select/DataSelect";
import Card from "@/components/common/card/Card";
import type { testSelectorProps } from "./types.props";

const TestSelector: React.FC<testSelectorProps> = ({
    sessions,
    selectedSessionId,
    selectedTestId,
    onSessionChange,
    onTestChange,
}) => {
    const availableTests =
        sessions.find((s) => s.id === selectedSessionId)?.tests || [];
    const testTypeOptions = availableTests.map((t) => ({
        value: t.id,
        label: t.test_type.name,
    }));

    return (
        <Card>
            <Tabs
                items={sessions.map((s) => ({ key: String(s.id), label: s.name }))}
                activeKey={String(selectedSessionId || "")}
                onTabChange={(key) => onSessionChange(Number(key))}
            />
            <DataSelect
                label="Seleccione una prueba para configurar:"
                value={String(selectedTestId || "")}
                onChange={(e) =>
                    onTestChange(e.target.value ? Number(e.target.value) : null)
                }
                options={testTypeOptions}
                placeholder="Seleccionar..."
            />
        </Card>
    );
};

export default TestSelector;
